// extracted by mini-css-extract-plugin
export default {"message_container":"PageNotFound_message_container__kG4tb","text":"PageNotFound_text__Lt7tQ"};